{
    "reorders__empty_title": "Keine Empfehlungen für diesen Kunden",
    "reorders__empty_body": "Hier findest du sonst Artikel die der Kunde bald wieder benötigen könnte.",

    "modal_title": "Artikel wählen",
    "search_variants_placeholder": "Suche nach Produkte, etc.",

    "table_header__article_id": "Artikel ID",
    "table_header__article_name": "Artikel",
    "table_header__last_quantitiy": "Menge bestellt",
    "table_header__last_order_date": "Letzte Bestellung",

    "submit_button": "Artikel Hinzufügen"
}
